export type DeleteDialogTranslation = {
  cancelButtonLabel: string;
  confirmButtonLabel: string;
  content: string;
  title: string;
};

export const deleteDialogTranslation: DeleteDialogTranslation = {
  cancelButtonLabel: 'Anuluj',
  confirmButtonLabel: 'Usuń',
  content: 'Potwierdź usunięcie: ',
  title: 'Czy na pewno chcesz usunąć ten element?',
};
